import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ProjectService } from 'src/app/core/services/project.service';
import { LoadingPlacesOptions, WorkSpace } from 'src/app/core/types';

@Component({
    selector: 'gl-load-loading-places',
    templateUrl: './load-loading-places.component.html',
    styleUrls: ['./load-loading-places.component.scss'],
    standalone: false
})
export class LoadLoadingPlacesComponent implements OnDestroy, OnInit, OnDestroy {
  @Output() public loadingPlacesOptions = new EventEmitter<LoadingPlacesOptions>();
  @Input() public defaultValue: LoadingPlacesOptions;
  public form: CustomForm;
  public stops: WorkSpace[];
  public destinationStops: WorkSpace[];
  private subscriptions: Subscription[] = [];

  constructor(private projectService: ProjectService) {
    this.subscriptions.push(
      this.projectService.project.subscribe((project) => {
        this.stops = project.workSpaces[this.projectService.getCurrentWorkSpace()].stops;
        this.destinationStops = project.workSpaces[this.projectService.getCurrentWorkSpace()].stops;
      }),
    );
    this.form = this.generateForm();
    this.form.controls.destination.disable();
    this.subscriptions.push(
      this.form.controls.origin.valueChanges.subscribe((value) => {
        if (value) {
          this.form.controls.destination.enable();
          this.form.controls.destination.setValue(undefined);
          this.destinationStops = this.stops.filter((stop) => stop.id > value.id);
        } else {
          this.form.controls.destination.disable();
        }
      }),
    );
    this.subscriptions.push(this.form.valueChanges.subscribe(() => this.onSubmit()));
  }

  public ngOnInit(): void {
    if (this.defaultValue?.origin && this.defaultValue?.destination) {
      this.form.controls.origin.setValue(
        this.stops.find((stop) => stop.id === this.defaultValue.origin.id),
      );
      this.form.controls.destination.setValue(
        this.destinationStops.find((stop) => stop.id === this.defaultValue.destination.id),
      );
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  public onSubmit(): void {
    if (this.form.value.origin && this.form.value.destination) {
      this.loadingPlacesOptions.emit({
        origin: {
          name: this.form.value.origin.name,
          id: this.form.value.origin.id,
        },
        destination: {
          name: this.form.value.destination.name,
          id: this.form.value.destination.id,
        },
      });
    }
  }

  private generateForm() {
    return new UntypedFormGroup({
      origin: new UntypedFormControl(null, Validators.required),
      destination: new UntypedFormControl(null, Validators.required),
    });
  }
}

interface CustomForm extends UntypedFormGroup {
  value: {
    origin: WorkSpace;
    destination: WorkSpace;
  };
}
